export enum SearchScenarioId {
    Mail = 1,// Search box for mail module
    Calendar = 2,// Search box for calendar module
    // FilesHub = 3, // DEPRECATED. Search box for files module
    // FilesPicker = 4, // DEPRECATED. Search box in files picker (for attaching emails)
    // FileSuggestions = 5, // DEPRECATED. Search box in hyperlink dialog (generate file suggestions)
    GroupsMail = 6,// Search box for groups module
    People = 7
}

export default SearchScenarioId;
